import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 11 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.0636 10.5V5M0.5 6V9.5C0.5 10.0523 0.959105 10.5 1.52544 10.5H8.40932C9.16855 10.5 9.81417 9.95985 9.92963 9.2281L10.4818 5.7281C10.6251 4.81945 9.9042 4 8.96152 4H7.16536C6.88218 4 6.65264 3.77614 6.65264 3.5V1.73292C6.65264 1.05199 6.08659 0.5 5.38837 0.5C5.22179 0.5 5.0709 0.59565 5.00327 0.74406L3.19893 4.70305C3.11663 4.88365 2.93302 5 2.7304 5H1.52544C0.959105 5 0.5 5.4477 0.5 6Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgThumbsUp;
